import haplapLogo from "../assets/haplap-logo.png";

export const THEMES = {
  copper: { name: "Blossom", cover: "theme-copper" },
  sage: { name: "Mint", cover: "theme-sage" },
  rose: { name: "Peach", cover: "theme-rose" },
  gold: { name: "Buttercup", cover: "theme-gold" },
  cream: { name: "Lavender", cover: "theme-cream" },
};

export const TAGS = ["Rent", "Medical", "Food", "Family", "Housing", "Recovery", "ArtBusker",
  "Music", "Art", "Education", "Student", "Veteran", "Disability", "Pets", "Clothing",
  "SingleParent", "Senior", "Youth", "Homeless"];

export const GENDERS = [
  { value: "", label: "Everyone" },
  { value: "female", label: "Women" },
  { value: "male", label: "Men" },
  { value: "nonbinary", label: "Non-binary" },
];

export const GENDER_OPTIONS = [
  { value: "none", label: "Prefer not to say" },
  { value: "female", label: "Woman" },
  { value: "male", label: "Man" },
  { value: "nonbinary", label: "Non-binary" },
];

export const ROOM_THEMES = [
  { id: "blossom", name: "Blossom", class: "bg-gradient-to-b from-rose-50 via-orange-50 to-amber-50" },
  { id: "mint", name: "Mint", class: "bg-gradient-to-b from-emerald-50 via-teal-50 to-green-50" },
  { id: "lavender", name: "Lavender", class: "bg-gradient-to-b from-purple-50 via-indigo-50 to-fuchsia-50" },
  { id: "buttercup", name: "Buttercup", class: "bg-gradient-to-b from-amber-50 via-yellow-50 to-orange-50" },
  { id: "paper", name: "Paper", class: "bg-secondary/40" },
];

export const STICKERS = ["🌻", "💛", "☕", "🕊️", "🍞", "🎻", "🐾", "✨", "🙏", "🤝", "🌈", "🫶",
  "🌱", "☀️", "🧡", "💐", "🎨", "📖", "🍀", "😊"];

export const LOGO = haplapLogo;
export const HERO = "https://static.prod-images.emergentagent.com/jobs/40acd7df-38cb-40a5-af80-2b7bac12c4d9/images/e1d81c1240f334bcad5f3247aa3a078e8ade62f7169ae80613e63fe279833fd8.jpeg";

// Warm, heart-tugging preset vouches for "Under Our Wing" (protected) members.
// Admins pick one, tweak it, polish with AI, or write their own. No real names.
export const PROTECTED_PRESETS = [
  "A parent doing everything they possibly can for their children. They asked us to keep their name private so their kids are never singled out or made to feel different — and we understand that completely. We've met them, verified every detail, and we can tell you with our whole hearts: they are real, and they need us. 🤍",
  "Someone whose pride makes asking for help feel almost impossible. Quietly, and with so much courage, they proved to our team exactly who they are and what they're facing. Out of deep respect for them, we're keeping their identity ours alone. Please trust us — this neighbour truly needs a hand. 🤍",
  "A family walking through one of the hardest seasons of their lives. They were frightened of being recognized, so they let us carry their story for them instead. We've verified every piece of it. They are safe to support, and so very, very deserving. 🤍",
  "Health struggles have made life unbearably heavy for this neighbour. They couldn't bring themselves to ask out loud, so they came to us privately — with proof, with honesty, and with more bravery than most of us will ever need. We're holding their name close. Your kindness would mean the world. 🤍",
  "A hardworking person who fell on unexpected times and is simply too ashamed to be seen asking. They've shown us the truth of their situation, and we believe in them completely. We're keeping them anonymous — but we promise you, from the bottom of our hearts, this is real. 🤍",
  "Someone pouring everything into caring for the people they love, while quietly running on empty themselves. They asked to stay unseen to protect their family's dignity. We've checked every detail, and we stand firmly behind them. Please help them the way you'd hope someone would help you. 🤍",
];

export const THANK_YOU_PRESETS = [
  "Thank you so much — your kindness truly made my day. 💛",
  "I can't put into words how much your support means. Bless you! 🙏",
  "You didn't have to, but you did — and I'm forever grateful. 🫶",
  "Your generosity is giving me real hope again. Thank you from the bottom of my heart.",
  "Because of people like you, I don't feel so alone anymore. Thank you.",
  "This means more than you'll ever know. Thank you for believing in me. ✨",
];
